import React, { useState, useCallback, useMemo } from "react";
import "./BlogSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import Markdown from "react-markdown";

export const BlogSection = ({ sectionTitle, sectionNumber, sectionBody, expand }) => {
    const title = sectionTitle || "Section Title";
    const body = sectionBody || "Section Body";
    const startExpand = expand !== undefined ? expand : true;

    const [isExpanded, setIsExpanded] = useState(startExpand);
    const [isTruncated, setIsTruncated] = useState(true);

    const toggleDropdown = useCallback(() => {
        setIsExpanded((prev) => !prev);
    }, []);

    const showMore = useCallback(() => setIsTruncated(false), []);
    const showLess = useCallback(() => setIsTruncated(true), []);

    const truncatedBody = useMemo(() => {
        const charLimit = 260;
        if (!body) return "";
        if (body.length <= charLimit) return body;
        return body.slice(0, charLimit).trim() + "…";
    }, [body]);

    return (
        <div className={`blog-section-container ${isExpanded ? "expanded" : ""}`}>
            <div className="blog-section-header" onClick={toggleDropdown} role="button" tabIndex={0}>
                <div className="blog-section-title">
                    <p>{title}</p>
                </div>
                <div className="blog-section-caret-icon">
                    <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
                </div>
            </div>

            {isExpanded && (
                <div className="blog-section-body">
                    {isTruncated && body.length > 260 ? (
                        <>
                            <div className="blog-section-text">
                                <Markdown components={{ p: (props) => <span {...props} /> }}>
                                    {truncatedBody}
                                </Markdown>
                            </div>
                            <button
                                type="button"
                                className="inline-more-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    showMore();
                                }}
                            >
                                Read more
                            </button>
                        </>
                    ) : (
                        <>
                            <div className="blog-section-text">
                                <Markdown>{body}</Markdown>
                            </div>
                            {body.length > 260 && (
                                <div className="below-less-wrap">
                                    <button
                                        type="button"
                                        className="below-less-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            showLess();
                                        }}
                                    >
                                        Show less
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};
